/** What Messaging's windows share that isn't a component: the phone's big button, and Copy. */
import { useEffect, useState } from "react";

/** A phone's full-width button: the solid one, or the outlined. */
export const BIG = "h-auto w-full rounded-lg px-4 py-3.25 text-base leading-5";

/** A Copy that says Copied for a moment. */
export function useCopy(): [boolean, (text: string) => void] {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(t);
  }, [copied]);
  const copy = (text: string) => {
    void navigator.clipboard
      ?.writeText(text)
      .then(() => setCopied(true))
      .catch(() => {});
  };
  return [copied, copy];
}
